import React from "react"
import { withTheme } from "emotion-theming"

const Facebook = ({ theme, colour }) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 8 16">
    <path
      fill={colour || theme.colour}
      d="M7.4001.733171V3.0665c0 .13334 0 .13334-.13333.13334h-1.2c-.13334 0-.26667 0-.40001.06666-.33333.06667-.46666.33334-.53333.6v1.6c0 .06667.06667.06667.13333.06667H7.4001c-.06667.86667-.2 1.66667-.26667 2.46667h-2v7.19996H2.4001V7.93317H.600098v-2.4c0-.13333 0-.13333.133333-.13333H2.26676c.13334 0 .13334-.06667.13334-.13334v-2c0-.46666.13333-.93333.33333-1.4.26667-.46666.66667-.8 1.13333-.999996.26667-.066667.6-.133333.86667-.2h.13334C5.73343.733171 6.6001.733171 7.4001.733171z"
    />
  </svg>
)

export default withTheme(Facebook)
